export type SettingName =
  | 'isRichText'
  | 'isCharLimit'
  | 'isMaxLength'
  | 'isCharLimitUtf8'
  | 'showTreeView'
  | 'showTableOfContents'
  | 'tableCellMerge'
  | 'tableCellBackgroundColor';

export type Settings = Record<SettingName, boolean>;

export const DEFAULT_SETTINGS: Settings = {
  isRichText: true,

  showTreeView: true,
  tableCellMerge: true,

  tableCellBackgroundColor: true,

  isCharLimit: false,
  isCharLimitUtf8: false,

  isMaxLength: false,
  showTableOfContents: false,
};
